/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { connect } from "react-redux";
import { dateDueBreakDownAction } from "../../../redux/action-creators/dateDueBreakDownActionCreator";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import "./dateDetail.css";
import DateDetailPage from "./DateDetailPage";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  grid: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  tab: {
    marginLeft: theme.spacing(4),
  },
  picker: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "-15px",
    display: "flex",
  },
  title: {
    flexGrow: 1,
  },
}));

function DateDetail(props) {
  const isFirstRender = React.useRef(0);
  const classes = useStyles();

  React.useEffect(() => {
    if (isFirstRender.current !== 2) {
      isFirstRender.current += 1;
    } else {
      props?.history?.push("/settlement");
    }
  }, [props?.cityFilter]);

  return (
    <DateDetailPage {...{ ...props, useStyleClasses: classes }} />
  );
}

function mapStateToProps(state) {
  return {
    content: state.DateDue.dateDueBreakDown,
    config: state.DateDue.dateDueBreakDown.calculationConfig,
    totalItem: state.DateDue.dateDueBreakDown.totalItems,
    cityFilter: state.Cities.selectedCity,
    collectionLoader: state && state.loadingBar && state.loadingBar.collectionLoader,
    gridLoader: state && state.loadingBar && state.loadingBar.gridLoader,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchDateDueBreakDown: (params, loaderScope) => {
    dispatch(dateDueBreakDownAction(params, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DateDetail);
